import { useTexts } from '../../../../contexts/TextsContext';
import SectionTitle from '../shared/sectionTitle/SectionTitle';
import classes from './about.module.scss';

const About = () => {
    const texts = useTexts();

    return (
        <section className={classes.About} id="about" aria-labelledby="about-heading">
            <div className={classes.Inner}>
                <SectionTitle
                    id="about-heading"
                    primaryText={texts.aboutHeadingAccent}
                    secondaryText={texts.aboutHeadingMain}
                />
                <p className={`${classes.Body} ${classes.BodyDesktop}`}>{texts.aboutBody}</p>
                <p className={`${classes.Body} ${classes.BodyMobile}`}>{texts.aboutBodyMobile}</p>
            </div>
        </section>
    );
};

export default About;
